// CARTO vereist sinds 29-09-2026 een ?key= op elke tile-URL (anders watermerk-tiles).
const CARTO_KEY = document.querySelector('meta[name="carto-key"]')?.content ?? '';
const carto = (style) => `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png`
    + (CARTO_KEY ? `?key=${encodeURIComponent(CARTO_KEY)}` : '');

export const TILES = {
    dark: carto('dark_all'),
    light: carto('light_all'),
    'dark-simple': carto('dark_nolabels'),
    'light-simple': carto('light_nolabels'),
    satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    hybrid: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
};

export const HYBRID_LABELS = carto('dark_only_labels');

// Bronvermelding is verplicht (CARTO- en Esri-voorwaarden); volgt de actieve tile-modus.
const ATTR_CARTO = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>';
const ATTR_ESRI = 'Tiles &copy; Esri';
export const TILE_ATTRIBUTION = {
    dark: ATTR_CARTO,
    light: ATTR_CARTO,
    'dark-simple': ATTR_CARTO,
    'light-simple': ATTR_CARTO,
    satellite: ATTR_ESRI,
    hybrid: ATTR_ESRI + ' ' + ATTR_CARTO,
};

export const PIN_COLORS = {
    Brandweer: '#e74c3c',
    Ambulance: '#f39c12',
    Politie: '#3498db',
    Lifeliner: '#9b59b6',
    KNRM: '#1abc9c',
    Reddingsbrigade: '#e67e22',
    Veiligheidsregio: '#27ae60',
    Meldkamer: '#27ae60',
};

export const DISC_BADGE = {
    Brandweer: 'b-bw',
    Ambulance: 'b-amb',
    Politie: 'b-pol',
    Lifeliner: 'b-life',
    KNRM: 'b-knrm',
    Reddingsbrigade: 'b-knrm',
    Veiligheidsregio: 'b-vr',
    Meldkamer: 'b-vr',
};

export const DISC_LETTER = {
    Brandweer: 'B',
    Ambulance: 'A',
    Politie: 'P',
    Lifeliner: 'L',
    KNRM: 'K',
    Reddingsbrigade: 'R',
    Veiligheidsregio: 'V',
    Meldkamer: 'M',
};

export const ACC_LABELS = {
    10: 'Station (fallback)', 20: 'Stad', 30: 'Straat',
    35: 'Hectometerpaal', 40: 'Adres', 45: 'Postcode+adres',
};
